import React from "react";
import { Link } from "react-router-dom";
import AdminDashboard from "../admindashboard";
import "../hm-theme.css";

function Reportspage() {
  return (
    <div>
      <AdminDashboard />
      <div className="col-12 mx-xl-auto ps-xl-10 mt-10 pe-xl-4">
        <div className="hm-page-wrapper">

          {/* Page Header */}
          <div className="hm-page-header mb-4">
            <div>
              <h2 className="hm-page-title">
                <i className="material-icons">bar_chart</i>
                Reports
              </h2>
              <p className="hm-page-subtitle">View and download appointment reports</p>
            </div>
          </div>

          {/* Appointment Report Card */}
          <div className="hm-card mb-4">
            <div className="hm-card-header">
              <h3 className="hm-card-title">
                <i className="material-icons">event_note</i>
                Appointment Report
              </h3>
            </div>
            <div className="hm-card-body">
              <div className="hm-report-nav-grid">

                <Link
                  to="/users/viewReportsTrandsactionDateForAdmin"
                  className="hm-report-nav-card"
                >
                  <div className="hm-report-nav-icon cyan">
                    <i className="material-icons">receipt_long</i>
                  </div>
                  <div>
                    <p className="hm-report-nav-label">By Transaction Date</p>
                    <p className="hm-report-nav-sub">Filter reports by payment date</p>
                  </div>
                  <i className="material-icons ms-auto text-muted" style={{ fontSize: "1.1rem" }}>
                    chevron_right
                  </i>
                </Link>

                <Link
                  to="/users/viewReportsByAdmin"
                  className="hm-report-nav-card"
                >
                  <div className="hm-report-nav-icon blue">
                    <i className="material-icons">calendar_month</i>
                  </div>
                  <div>
                    <p className="hm-report-nav-label">By Appointment Date</p>
                    <p className="hm-report-nav-sub">Filter reports by appointment date</p>
                  </div>
                  <i className="material-icons ms-auto text-muted" style={{ fontSize: "1.1rem" }}>
                    chevron_right
                  </i>
                </Link>

              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}

export default Reportspage;
